// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 807) return "static/chunks/807-58e06d2415797422.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 43 ? "58a6c8d1" : chunkId) + "." + {"8":"3a67dea05be4a745","43":"4d6b6426ca2a8a75","528":"19919fc69da03f0b","824":"61b1f8ec535778d8"}[chunkId] + ".js";
};